import React, { useEffect } from "react";
import { useSettings } from "../../contexts/AppContext";

export default function MetaTags() {
  const settings = useSettings();
  const { meta_title, meta_description, meta_keywords, og_title, og_description, og_image, og_type } = settings;
  const canonicalUrl = typeof window !== 'undefined' ? window.location.origin + window.location.pathname : '';

  useEffect(() => {
    const setMeta = (name, content, isProperty = false) => {
      if (!content) return;
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    if (meta_title) {
      document.title = meta_title;
    }
    setMeta('description', meta_description);
    setMeta('keywords', meta_keywords);
    setMeta('og:title', og_title || meta_title, true);
    setMeta('og:description', og_description || meta_description, true);
    setMeta('og:image', og_image, true);
    setMeta('og:type', og_type || 'website', true);
    setMeta('og:url', canonicalUrl, true);
  }, [meta_title, meta_description, meta_keywords, og_title, og_description, og_image, og_type, canonicalUrl]);

  return null;
}
